import { Skeleton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectOrderDetails, selectOrderDetailsLoading } from 'redux/reducers/euDdp/selectors';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { EasCard } from 'ui/EasCard';

export const AmountBreakdown: FC = () => {
	const order = useSelector(selectOrderDetails);
	const orderIsLoading = useSelector(selectOrderDetailsLoading);

	return (
		<div>
			{order && !orderIsLoading ? (
				<EasCard id="eu-ddp-order-amount-breakdown" title="Amount Breakdown">
					<TableContainer>
						<Table>
							<TableBody>
								<TableRow>
									<TableCell sx={{ padding: '5px', borderBottom: 0 }}>Total Amount:</TableCell>
									<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
										<AmountAndCurrency
											amount={order?.order.total_order_value ?? 0}
											currency={order?.order.payment_currency}
										/>
									</TableCell>
								</TableRow>

								{(order?.order.import_threshold ?? 0) > 0 && (
									<TableRow>
										<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
											Calculated Import Threshold:
										</TableCell>
										<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
											<AmountAndCurrency
												amount={order?.order.import_threshold ?? 0}
												currency={order?.order.threshold_currency ?? 'EUR'}
												size={0.9}
											/>
										</TableCell>
									</TableRow>
								)}
								{+(order?.order.import_threshold ?? 0) > 0 &&
									order?.order.payment_currency !== order?.order.threshold_currency && (
										<TableRow>
											<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
												Threshold Exchange Rate Applied:
											</TableCell>
											<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
												<AmountAndCurrency
													amount={1}
													currency={order?.order.payment_currency ?? 'EUR'}
													size={0.9}
													afterPoint={0}
												/>{' '}
												={' '}
												<AmountAndCurrency
													amount={order?.order.intrinsic_threshold_exchange_rate ?? 1}
													currency={order?.order.threshold_currency ?? 'EUR'}
													size={0.9}
													afterPoint={6}
												/>
											</TableCell>
										</TableRow>
									)}

								{!!order?.order.daily_exchange_rate &&
									order?.order.payment_currency !== order?.order.threshold_currency && (
										<TableRow>
											<TableCell sx={{ padding: '2px', borderBottom: 0 }}>
												Daily Exchange Rate:
											</TableCell>
											<TableCell align="right" sx={{ padding: '2px', borderBottom: 0 }}>
												<AmountAndCurrency
													amount={1}
													currency={order?.order.payment_currency ?? 'EUR'}
													size={0.9}
													afterPoint={0}
												/>{' '}
												={' '}
												<AmountAndCurrency
													amount={order?.order.daily_exchange_rate ?? 1}
													currency={order?.order.threshold_currency ?? 'EUR'}
													size={0.9}
													afterPoint={6}
												/>
											</TableCell>
										</TableRow>
									)}
							</TableBody>
						</Table>
					</TableContainer>
				</EasCard>
			) : (
				<Skeleton variant="rectangular" height="128px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
